import { Color, HSL, SRGBColorSpace } from 'three';

/**
 * Lowest sRGB lightness a part's own colour is drawn at. Below it a part
 * shows almost no shading and disappears into the dark viewport background.
 */
export const PART_MIN_LIGHTNESS = 0.3;

/**
 * The colour a part is drawn in for its stored `#rrggbb` colour: the same
 * hue and saturation, lifted to PART_MIN_LIGHTNESS when darker. The stored
 * colour itself is left unchanged; anything that is not `#rrggbb` passes
 * through as given.
 */
export function readablePartColor(color: string): string {
  if (!/^#[0-9a-f]{6}$/i.test(color)) return color;

  const rgb = new Color();
  rgb.setStyle(color, SRGBColorSpace);
  const hsl: HSL = { h: 0, s: 0, l: 0 };
  rgb.getHSL(hsl, SRGBColorSpace);
  if (hsl.l >= PART_MIN_LIGHTNESS) return color;

  rgb.setHSL(hsl.h, hsl.s, PART_MIN_LIGHTNESS, SRGBColorSpace);
  return `#${rgb.getHexString(SRGBColorSpace)}`;
}
